<template>
  <div v-loading="loading">
    <div
      class="flex items-center cursor-pointer pl-2"
      @click="isLocationFormModal = true"
    >
      <p class="text-xl font-bold text-darkBlue">Add</p>
      <img src="./icons/add.svg" alt="add icon" class="pl-2" />
    </div>
    <div class="table-wrapper mt-2 p-2" id="table-wrapper">
      <table class="custom-table responsive-table m-0">
        <thead>
          <tr>
            <th><base-checkbox v-model="selectAll" /></th>
            <th>Address</th>
            <th>City/State</th>
            <th>Country</th>
            <th>Type</th>
            <th>Shipping Count</th>

            <th>
              <div class="flex justify-end items-center mr-6">
                <img
                  src="@/assets/images/icons/table-action.svg"
                  alt="actions"
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="location in locations" :key="location.id">
            <td>
              <base-checkbox v-model="selectedLocations" :value="location.id" />
            </td>
            <td class="w-3/12">{{ location && location.address ? location.address.name : "" }}</td>
            <td>{{ location.city ? `${location.city}/` : '' }}{{ location.state }}</td>
            <td>{{ location && location.name ? locationCountry(location.name) : '' }}</td>
            <td class="capitalize">{{ location.type }}</td>
            <td class="text-center">{{ location && location.count}}</td>

            <td
              class="flex items-center cursor-pointer justify-end"
              style="height: 54px"
            >
              <span class="mr-4">
                <el-switch
                  v-model="location.isDefault"
                  active-color="#ffa600"
                  inactive-color="#EEEEEE"
                  @change="updateDefaultLocation($event, location.location_id[0])"
                >
                </el-switch>
              </span>
              <span
                class="flex items-center mr-3"
                @click="editLocation(location)"
              >
                <span class="hidden"><img src="./icons/edit.svg" alt="edit icon" /></span>
                <span class="pl-1 hidden">Edit</span>
              </span>
              <span
                class="flex items-center px-2 mr-3"
                @click="(selectedLocation = location), (isDeleteModal = true)"
              >
                <span class="hidden"><img src="./icons/delete.svg" alt="edit icon" /></span>
                <span class="pl-1 hidden">Remove</span>
              </span>
              <span
                class="flex items-center mr-3"
                @click="viewLocation(location)"
              >
                <span><img src="./icons/eye.svg" alt="edit icon" /></span>
                <span class="pl-1"> View location</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!locations.length">
      <empty-state description="No Locations Found!" />
    </div>

    <div class="px-2" v-if="locations.length">
      <PaginationControl
        :total="30"
        :pageNumber="1"
        @pageNumber="setPageDisplay"
        @pageSize="setNumDisplay"
      />
    </div>

    <location-form
      :show-modal="isLocationFormModal"
      @close-modal="isLocationFormModal = false"
      :selectedLocationDetails="selectedLocation"
      @completed="getAllLocations"
    />

    <delete-modal
      :show-modal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      :location="selectedLocation"
      @deleted="getAllLocations"
    />

    <google-map
      :center="center"
      :show-modal="isMapModal"
      @close-modal="isMapModal = false"
    />
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/pagination";
import LocationForm from "./Modals/LocationForm";
import DeleteModal from "./Modals/DeleteModal";
import GoogleMap from "../GoogleMap.vue";

// import debounce from "@/utilities/debounce";

export default {
  components: {
    PaginationControl,
    LocationForm,
    DeleteModal,
    GoogleMap,
  },
  props: ["searchString"],
  data() {
    return {
      locations: [],
      pageNumber: 1,
      pageSize: 10,
      isLocationFormModal: false,
      isPrimary: true,
      isDeleteModal: false,
      selectedLocation: null,
      center: {},
      isMapModal: false,
      loading: false,
      selectedLocations: [],
      selectAll: false,
    };
  },
  watch: {
    payload() {
      this.getAllLocations();
    },

    selectAll(value) {
      if (value) {
        this.locations.forEach((location) => {
          this.selectedLocations.push(location.id);
        });
      } else {
        this.selectedLocations = [];
      }
    },
  },
  computed: {
    payload() {
      return {
        userId: localStorage.getItem("userId"),

        pageSize: this.pageSize,
        searchTerm: this.searchString,
        pageNumber: this.pageNumber,
      };
    },
  },
  mounted() {
    this.getAllLocations();
  },
  methods: {
    locationCountry(location){
      location = location.split(',')
      console.log("[[[[[[[[[[[[[[[[", location)
      return location[location.length - 1]
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
    async getAllLocations() {
      this.loading = true;
      try {
        const response = await this.$_getAllBookingLocations(this.payload)
        this.locations = response.data.data.locations;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async updateDefaultLocation(value, locationId) {
      // this.loading = true;
      console.log(value, locationId);
      const locationPayload = {
        isDefault: value,
        user_id: localStorage.getItem("userId")
      }

      try {
        const response = await this.$_setDefaultLocation(locationId, locationPayload);
        this.getAllLocations();
        this.log(response);
        this.generateToast("Location has been set as default!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    editLocation(location) {
      this.selectedLocation = location;
      this.isLocationFormModal = true;
    },
    viewLocation(location) {
      this.center = {
        lat: location?.address?.lat,
        lng: location?.address?.lng,
      };
      this.isMapModal = true;
    },
  },
};
</script>

<style scoped>
tr {
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
th {
  color: #7a90a7;
  font-size: 0.9rem;
  font-weight: normal;
}
th,
td {
  padding: 0.5rem;
}
td {
  color: #383f51;
  font-weight: 600;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
